import { StudentList } from "../../components/datatable/StudentList"
import { StudentEnrollmentList } from "../../components/datatable/StudentEnrollmentList"
import { CourseList } from "../../components/datatable/CourseList"
import { InstructorList } from "../../components/datatable/InstructorList"
import { TermList } from "../../components/datatable/TermList"
import { ThesisList } from "../../components/datatable/ThesisList"
import { ThesisAssignedList } from "../../components/datatable/ThesisAssignedList"
import { FeedbackList } from "../../components/datatable/FeedbackList"
import { StudentRequestList } from "../../components/datatable/StudentRequestList"
import { StudentFeedback } from "../../components/datatable/StudentFeedback"
import { AssignExaminerList } from "../../components/datatable/AssignExaminerList"
import { AnnouncementList } from "../../components/datatable/AnnouncementList"
import { StudentTermList } from "../../components/datatable/StudentTermList"
import { StudentGrades } from "../../components/datatable/StudentGrades"
import { Navbar } from "../../components/navbar/Navbar"
import { Sidebar } from "../../components/sidebar/Sidebar"
import { LectureList } from "../../components/datatable/LectureList"


import "./list.scss"

export const List = ({type}) => {
  return (
    <div className="list">
    <Sidebar/>
    <div className="listContainer">
        <Navbar/>
        {type === "student" && <StudentList/>}
        {type === "enrollment" && <StudentEnrollmentList/>}
        {type === "course" && <CourseList/>}
        {type === "instructor" && <InstructorList/>}
        {type === "term" && <TermList/>}
        {type === "thesis" && <ThesisList/>}
        {type === "feedback" && <FeedbackList/>}
        {type === "studentrequest" && <StudentRequestList/>}
        {type === "thesisAssigned" && <ThesisAssignedList/>}
        {type === "studentFeedbacks" && <StudentFeedback/>}
        {type === "assignexaminer" && <AssignExaminerList/>}
        {type === "announcement" && <AnnouncementList/>}
        {type === "assignterms" && <StudentTermList/>}
        {type === "grade" && <StudentGrades/>}
        {type === "lecturelink" && <LectureList/>}
       
    </div>
    </div>
  )
}


export default List
